import React ,{useState}from 'react';
import useWhatsapp from '../hooks/thankyou'
import IconSelector from '@ibibo/icon-selector';

import * as S from '../Links/Links.styles';

const LinksBlock = ({actions,status}) => {
  const [whatsAppModal, popUpmodal,  authenticate] = useWhatsapp(status,actions)

  return (
  <>
  {whatsAppModal}
  {popUpmodal}
  <S.BookingOptionOuterWrap>
    <S.LeftCircleCut />
    <S.RightCircleCut />
    <S.BookingOptionInnerWrap>
      {actions.map(item =>
      <S.BookingOptionWrap key={item.title} onClick = {() => {
        (item.icon == 'whatsapp' || item.icon == 'whatsapp-icon') ?
        authenticate(item.link) : window.open(item.link, '_blank');
      }}>
        <S.OptionIconWrap>
          <IconSelector iconKey={item.icon} />
        </S.OptionIconWrap>
        <S.OptionTextWrap >
          {item.icon != 'whatsapp' ? <S.OptionText>{item.title}</S.OptionText> :
          <>
          <S.OptionText >{item.title}</S.OptionText>
          <S.ProfileStatus>New</S.ProfileStatus>
          </>}
        </S.OptionTextWrap>
      </S.BookingOptionWrap>)}
    </S.BookingOptionInnerWrap>
  </S.BookingOptionOuterWrap>
  </>)
};


export default LinksBlock;
